module.exports = __webpack_public_path__ + "img/CSGO500.53efedd9.png";